import { createAction } from '@ngrx/store';

export const initializePortRoutingList = createAction(
  '[@zerops/zerops/features/port-routing-list] list-initilized',
  (projectId: string) => ({ projectId })
);
